<form [formGroup]=form>
    <h4 class="bk-modal__section-title">
        {{'Calculate Drip Application Rate' | translate }}
    </h4>

    <label class="bk-modal__label">
        {{'Emitter Discharge Rate' | translate }}
    </label>

    <input class="bk-field--has-calculation bk-modal__field--with-unit bk-input--short bk-modal__field"
        type="number"
        step="0.01"
        formControlName="EmitterDischargeRate"
        required/>
    <div class="bk-modal__field-unit">
        {{ 'gallons' | translate }}/{{ 'hour' | translate }}
    </div>
	
    <label class="bk-modal__label">
        {{'Emitters Per Tree' | translate }}
    </label>

    <input class="bk-field--has-calculation bk-modal__field--with-unit bk-input--short bk-modal__field"
        type="number"
        step="0.01"
        formControlName="EmittersPerTree"
        required/>

    <div class="bk-clearfix">
        <mat-radio-group
            aria-label=""
            name="useTreesPerAcre"
            formControlName="UseTreesPerAcre">

            <mat-radio-button [value]="false"
                name="useTreesPerAcre">
                {{'Row Spacing' | translate}}
            </mat-radio-button>

            <mat-radio-button class="mat-radio-button--left-margin"
                [value]="true"
                name="useTreesPerAcre">
                {{'Trees per Acre' | translate}}
            </mat-radio-button>
        </mat-radio-group>
    </div>

    <ng-container *ngIf="f.UseTreesPerAcre.value">
        <label class="bk-modal__label">
            {{'Trees Per Acre' | translate }}
        </label>

        <input class="bk-field--has-calculation bk-modal__field--with-unit bk-input--short bk-modal__field"
            type="number"
            step="0.01"
            formControlName="TreesPerAcre"
            required/>
    </ng-container>

    <ng-container *ngIf="f.UseTreesPerAcre.value === false">
        <label class="bk-modal__label">
            {{'Row Spacing' | translate }}
        </label>

        <input class="bk-field--has-calculation bk-modal__field--with-unit bk-input--short bk-modal__field"
            type="number"
            step="0.01"
            formControlName="RowSpacing"
            required/>
        <div class="bk-modal__field-unit">
            {{ 'ft' | translate }}
        </div>

        <label class="bk-modal__label">
            {{'In Row Tree Spacing' | translate }}
        </label>

        <input class="bk-field--has-calculation bk-modal__field--with-unit bk-input--short bk-modal__field"
            type="number"
            step="0.01"
            formControlName="InRowTreeSpacing"
            required/>
        <div class="bk-modal__field-unit">
            {{ 'ft' | translate }}
        </div>
    </ng-container>
    

	<!-- footer -->
	
    <div class="bk-modal__section-buttons">
        <button class="bk-button bk-button--medium bk-button--text-only"
            (click)="cancel($event)">
            {{'Cancel' | translate }}
        </button>
        <button class="bk-button bk-button--medium"
            [disabled]='form.invalid'
            (click)="calculate($event)">
            {{'Calculate' | translate }}
        </button>
    </div>
</form>